import * as Sentry from "@sentry/vue";
import {PiniaPluginContext} from "pinia";

export default function piniaSentry({store}: PiniaPluginContext) {
    store.$onAction(({name, args, onError}) => {
        onError((err) =>
            Sentry.captureException(err, {
                tags: {store: store.$id, action: name},
                extra: {args},
            }),
        );
    });
}